import React from 'react';

/** Toggle de columnas móvil vía data-attributes (parlay / legacy). */
export function handleScheduleColumnToggle(event: React.MouseEvent<HTMLDivElement>): void {
  const target = event.currentTarget;
  const isSmallScreen = window.innerWidth < 992;

  if (isSmallScreen && target.classList.contains('total-container')) {
    document.querySelectorAll('.spread-container').forEach(spread => {
      spread.classList.toggle('d-none');
    });
  }

  const toggleSelector = target.getAttribute('data-toggle');
  const pairSelector = target.getAttribute('data-pair');
  const isFull = target.getAttribute('data-is-full');
  const mode = target.getAttribute('data-restore');

  if (mode) {
    target.removeAttribute('data-restore');
    document.querySelectorAll(`.main-markets`).forEach(element => {
      element.classList.add('d-none');

      if (element.classList.contains('market-0') || element.classList.contains('market-2')) {
        element.classList.remove('d-none');
      }
    });

    return;
  }

  if (isFull) {
    const defaultD = target.getAttribute('data-default');
    document.querySelectorAll(`.main-markets`).forEach(element => {
      const isTheToggable = element.classList.contains(toggleSelector?.replace('.', '') || '');
      const isBlock = !element.classList.contains('d-none');

      if (isBlock && isTheToggable) {
        element.classList.add('d-none');
        document.querySelectorAll(defaultD || '').forEach(defEl => {
          defEl.classList.remove('d-none');
        });
      } else {
        if (isTheToggable) {
          element.classList.toggle('d-none');
        }

        if (!isTheToggable) {
          element.classList.add('d-none');
          element.setAttribute('data-restore', 'true');
        }
      }
    });

    return;
  }

  if (toggleSelector) {
    document.querySelectorAll(toggleSelector).forEach(element => {
      element.classList.toggle('d-none');
    });
  }

  if (pairSelector) {
    document.querySelectorAll(pairSelector).forEach(element => {
      element.classList.toggle('d-none');
    });
  }
}
